"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultLayerConfig = exports.defaultItemIconConfig = void 0;
var defaultItemIconConfig = {
    margin: {
        desktop: '0 10px 0 0',
        tablet: '0 10px 0 0',
        mobile: '0 10px 0 0'
    }
};
exports.defaultItemIconConfig = defaultItemIconConfig;
var defaultLayerConfig = {
    padding: {
        desktop: '80px 0 60px',
        tablet: '80px 0 60px',
        mobile: '80px 0 60px'
    }
};
exports.defaultLayerConfig = defaultLayerConfig;
//# sourceMappingURL=HeroHeader.js.map